export enum QualityCategory {
    SD = 'SD',
    HD = 'HD',
    UHD = 'UHD',    
    UHD_4K = 'UHD 4K',
    UHD_8K = 'UHD 8K'
}


